<template lang="html">
  <page :loading="false" :err="err" layoutClass="add-application">
    <h3>Add a Job Application</h3>
    <p class="pb-4">Please add the details to manually add a job application to the system.</p>
    <apply-hr @submit="submit" />
  </page>
</template>

<script>
import Page from '@/components/Page';
import ApplyHr from '@/components/jobs/applyHr';
import JobApplicationCreateMutation from '@/graphql/mutations/JobApplicationCreate.gql';

export default {
  components: {
    Page,
    ApplyHr,
  },
  data: () => ({
    err: null,
  }),
  methods: {
    async submit(form) {
      try {
        const { jobID, userID, ...create } = form;
        // const { data: { createJobApplication: { id } } } =
        await this.$apollo.mutate({
          mutation: JobApplicationCreateMutation,
          variables: {
            create: {
              job: { id: jobID },
              user: { id: userID },
              ...create,
              source: 'HR',
            },
          },
        });

        this.$router.replace({ name: 'ListApplications' });
      } catch (err) {
        this.$notifyErr(err);
      }
    }
  }
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/views/job-applications/AddApplication.vue